<div class="wrapper wrapper-content animated fadeInRight">
  @if (detail && tournament) {
    <section
      class="playoff-management"
      >
      <div class="ibox">
        <div class="ibox-title">
          <h5>Playoff Setup</h5>
          @if (detail.course; as course) {
            <div class="ibox-tools">
              <span class="label label-primary">{{ course.name }}</span>
              <span class="label label-info">{{ course.shortName }}</span>
            </div>
          }
        </div>
        <div class="ibox-content">
          <form class="m-t-sm" [formGroup]="courseForm" (ngSubmit)="addHole()">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">Course</label>
                  <select
                    class="form-control"
                    formControlName="courseId"
                    #courseSelect
                    (change)="onCourseChange(courseSelect.value)"
                    [disabled]="isSavingHole() || !detail"
                    >
                    <option value="">Select a course</option>
                    @for (course of courseOptions(); track trackCourse($index, course)) {
                      <option
                        [value]="course.courseId"
                        >
                        {{ course.courseName }}
                      </option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">Hole Number</label>
                  <select
                    class="form-control"
                    formControlName="holeNumber"
                    #holeSelect
                    (change)="onHoleChange(holeSelect.value)"
                  [disabled]="
                    isSavingHole() || !courseForm.value.courseId || !detail
                  "
                    >
                    <option value="">Select a hole</option>
                    @for (hole of currentCourseHoles(); track trackHole($index, hole)) {
                      <option
                        [value]="hole.number"
                        >
                        {{ hole.number }}
                      </option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label class="control-label">Par</label>
                  <input
                    class="form-control"
                    type="number"
                    formControlName="par"
                    min="1"
                    max="10"
                    [disabled]="isSavingHole() || !detail"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label class="control-label">Yardage</label>
                    <input
                      class="form-control"
                      type="number"
                      formControlName="yardage"
                      min="1"
                      [disabled]="isSavingHole() || !detail"
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="control-label">&nbsp;</label>
                      <div>
                        <button
                          type="submit"
                          class="btn btn-primary btn-block"
                          [disabled]="courseForm.invalid || isSavingHole() || !detail"
                          >
                          @if (isSavingHole()) {
                            <i
                              class="fa fa-spinner fa-spin m-r-xs"
                            ></i>
                          }
                          {{ isSavingHole() ? "Adding" : "Add Hole" }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button
                      type="button"
                      class="btn btn-warning"
                      [disabled]="!canRemoveLastHole() || isRemovingHole() || !detail"
                      (click)="removeLastHole()"
                      >
                      @if (isRemovingHole()) {
                        <i
                          class="fa fa-spinner fa-spin m-r-xs"
                        ></i>
                      }
                      {{
                      isRemovingHole() ? "Removing Hole" : "Remove Last Playoff Hole"
                      }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      } @else {
        <div class="alert alert-info">
          Select a playoff to manage holes and players.
        </div>
      }
</div>
